import Vue from "vue";
import Router from "vue-router";

Vue.use(Router)

export default new Router({
    routes: [
        //     {
        //     path:'/',
        //     name:'querycret',
        //     component: resolve => require(['@/components/QueryCret.vue'], resolve)
        // },
        {
            path: '/querycert/:raceid',
            name: 'querycret',
            component: resolve => require(['@/components/QueryCret.vue'], resolve)
        },
        {
            path: '/querycertsingle/:raceid',
            name: 'querycertsingle',
            component: resolve => require(['@/components/QueryCertSingle.vue'], resolve)
        },
        // {
        //     path:'/querycert/:raceid',
        //     name:'querycret',
        //     component: resolve => require(['@/components/QueryCertBen.vue'], resolve)
        // },
        // {
        //     path:'/querycert/:raceid',
        //     name:'querycret',
        //     component: resolve => require(['@/components/QueryCertADO.vue'], resolve)
        // },
        {
            path: '/cretdownload/:cardid/:raceid',
            name: 'cretdownload',
            component: resolve => require(['@/components/CretDownload.vue'], resolve)
        }, {
            path: '/queryinfo/:raceid',
            name: 'queryinfo',
            component: resolve => require(['@/components/QueryInfo.vue'], resolve)
        }, {
            path: '/scoredetail',
            name: 'scoredetail',
            component: resolve => require(['@/components/ScoreDetail.vue'], resolve)
        }, {
            path: '/sfsqueryinfo/:raceid',
            name: 'sfsqueryinfo',
            component: resolve => require(['@/components/SfsQueryInfoFront.vue'], resolve)
        }, {
            path: '/sfsquerydetail',
            name: 'sfsquerydetail',
            component: resolve => require(['@/components/SfsInfoDetail.vue'], resolve)
        }, {
            path: '/sfsqueryscore/:raceid',
            name: 'sfsqueryscore',
            component: resolve => require(['@/components/SfsQueryScoreFront.vue'], resolve)
        }, {
            path: '/sfsscoredetail',
            name: 'sfsscoredetail',
            component: resolve => require(['@/components/SfsScoreDetail.vue'], resolve)
        }, {
            path: '/dingqueryinfo/:raceid',
            name: 'dingqueryinfo',
            component: resolve => require(['@/components/DingQueryInfoFront.vue'], resolve)
        },{
            path: '/dingquerydetail',
            name: 'dingquerydetail',
            component: resolve => require(['@/components/DingQueryInfoDetail.vue'], resolve)
        }, {
            path: '/nikequery/:raceid',
            name: 'nikequery',
            component: resolve => require(['@/components/NikeScore.vue'], resolve)
        }, {
            path: '/sfsscoredetail',
            name: 'sfsscoredetail',
            component: resolve => require(['@/components/SfsScoreDetail.vue'], resolve)
        }, {
            path: '/sfsqueryinfoimg/:raceid',
            name: 'sfsqueryinfoimg',
            component: resolve => require(['@/components/SfsQueryInfoFrontImg.vue'], resolve)
        },{
            path: '/sfsquerydetailimg',
            name: 'sfsquerydetailimg',
            component: resolve => require(['@/components/SfsInfoDetailImg.vue'], resolve)
        },],
    mode: "hash"
})